module.exports = __webpack_public_path__ + "static/media/ukworkshow.2fb06e90.png";